export interface PartnerInfoBoxData {
  title: string;
  content: string;
}

export interface PartnerInfoBoxProps extends PartnerInfoBoxData {}
